import { uploadImage } from '@app/services/auth';
import React, { useEffect, useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import { MdImage, MdOutlineCancel, MdOutlinePictureAsPdf } from 'react-icons/md'
import { BsFiletypeMp3, BsFiletypeXlsx, BsFiletypeXls, BsFiletypeCsv, BsFileZip, BsFiletypeDocx } from 'react-icons/bs'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { createIssue } from '../../services/tasks';
import ImageViewer from 'react-simple-image-viewer';
import { useDispatch } from 'react-redux';
import handleStatus from '../../utils/ajax';
import { logoutUser } from '../../store/reducers/auth';
import GetTaskFile from '../getTaskFile/GetTaskFile';

function DropZone(props: any) {
    const [uploading, setUploading] = useState(false);
    let { acceptedFiles, getRootProps, getInputProps } = useDropzone();
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false); 
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const projectId = localStorage.getItem("TaskProjectId");
    const [show, setShow] = useState(false);
    const { setAttachments, attachments, removeHandler, mode, taskId } = props;



    const getFileExtentions = (file: any) => {
        const fileName = file.fileName.split('.')
        const ext = fileName.at(-1);

        const styles = { color: '17a2b8', height: 'auto', width: '70px' }

        if (ext === "png" || ext === "jpeg" || ext === "jpg" || ext === 'gif') {
            return <MdImage style={{ ...styles }} />;
        }
        if (ext === 'pdf') {
            return <MdOutlinePictureAsPdf style={{ ...styles }} />
        }
        if (ext === "mp3") {
            return <BsFiletypeMp3 style={{ ...styles }} />
        }
        if (ext === "xlsx") {
            return <BsFiletypeXlsx style={{ ...styles }} />
        }
        if (ext === "xls") {
            return <BsFiletypeXls style={{ ...styles }} />
        }
        if (ext === "csv") {
            return <BsFiletypeCsv style={{ ...styles }} />
        }
        if (ext === 'zip') {
            return <BsFileZip style={{ ...styles }} />
        }
        if (ext === 'docx') {
            return <BsFiletypeDocx style={{ ...styles }} />
        }
    }

    const openImageViewer = useCallback((index) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);

    const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
    };


    const FileCard = (props: any) => {
        return (<div className="shadow-lg p-3 m-1 bg-white rounded m-2 " style={{ width: '130px', padding: '5px' }}>
            <div className='d-flex align-items-center justify-content-between' style={{ cursor: mode === "Update" ? "pointer" : "" }}>
                {getFileExtentions(props.file)}
                <MdOutlineCancel onClick={() => removeHandler(props.file)} style={{ color: 'red', height: '20px', width: '20px', cursor: 'pointer', zIndex: '100px' }} title="Remove" />
            </div>
            <p style={{ fontSize: '13px', textAlign: 'start', margin: "4px 0 0 0" }}>{props.file.fileName.substring(0, 8) + '...'}</p>
        </div>)
    }

    const onUpdateUpload = async (file: any, taskId: string, projectId: string) => {
        setUploading(true);

        const hashResp = await uploadImage(file);
        handleStatus(hashResp.status, () => dispatch(logoutUser()), navigate);

        if (hashResp?.status === 200) {
            const hash = hashResp?.data?.hash;
            const fileName = hashResp?.data?.fileName;

            if (projectId) {
                const resp = await createIssue({ hash, taskId, projectId, fileName });
                if (resp.status === 200) {
                    const { createdBy, created_At, fileHash, fileName, projectId, taskId, updated_At, _id } = resp.data.data;
                    setAttachments((prev: any) => [...prev, { createdBy, created_At, fileHash, fileName, projectId, taskId, updated_At, _id }]);
                    toast.success("file uploaded successfully.")
                }
            }
        }
        setUploading(false);
    }


    const uploadFile = async (file: any) => {
        setUploading(true);

        const resp = await uploadImage(file);
        handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

        if (resp.status === 200) {
            toast.success("File Uploaded");
            setAttachments((prev) => [...prev, { fileHash: resp.data.hash, fileName: resp.data.fileName }])
        }
        else {
            toast.error("Unable to upload file")
        }
        setUploading(false);
    }

    useEffect(() => {

        if (mode === 'Update' && acceptedFiles.length > 0) {
            const requests = acceptedFiles.map((file, index) => {
                onUpdateUpload(file, taskId, projectId)
                if ((acceptedFiles.length - 1) === index) {
                    acceptedFiles.length = 0;
                }

            })
        }

        if (mode === 'Create' && acceptedFiles.length > 0) {
            const requests = acceptedFiles.map((file, index) => {
                uploadFile(file)
                if ((acceptedFiles.length - 1) === index) {
                    acceptedFiles.length = 0;
                }
            });
        }
    }, [acceptedFiles])

    return (<>
        <section className="container">
            <div style={{ border: '2px dotted black', borderRadius: '5px' }}>
                {uploading ? <div className="text-center">Uploading...</div> : (<div {...getRootProps({ className: 'dropzone' })} style={{ height: '100%', width: '100%' }}>
                    <input {...getInputProps()} />
                    <p className='mx-auto text-center m-2 p-4' style={{ width: '100%', height: '100%' }}>Drag 'n' drop the attachments here, or click to select files</p>
                </div>)}
            </div>

            <div className="d-flex flex-wrap flex-row">
                {mode === "Create" && attachments && attachments.map((file: any, index: number) =>
                    <FileCard key={index} fileName={file.fileName} file={file} />
                )}
                {mode === "Update" && <GetTaskFile attachments={attachments} removeHandler={removeHandler} mode={"Update"} />}
            </div>


        </section>
    </>
    );
}

export default DropZone;